import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "datatables.net";
import "datatables.net-bs5";
import "datatables.net-select-dt";
import "datatables.net-responsive-dt";
import "../../Destination/custom.css"; // Assuming custom styles are added here

const ProvinceDetails = () => {
  const tableRef = useRef(null);
  const [showForm, setShowForm] = useState(false);
  const [selectedProvince, setSelectedProvince] = useState(null);
  const [provinceDetails, setProvinceDetails] = useState([
    { province: "Western", status: "Active", id: 1 },
    { province: "Central", status: "Inactive", id: 2 },
    { province: "Southern", status: "Active", id: 3 },
    { province: "Northern", status: "Inactive", id: 4 },
  ]);

  const [formData, setFormData] = useState({
    province: "",
    status: "Active",
  });

  useEffect(() => {
    if (tableRef.current) {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
      $(tableRef.current).DataTable({
        responsive: true,
        paging: true,
        searching: true,
        info: true,
      });
    }
  }, [provinceDetails]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedProvince) {
      setProvinceDetails(
        provinceDetails.map((province) =>
          province.id === selectedProvince.id ? { ...formData, id: province.id } : province
        )
      );
    } else {
      setProvinceDetails([
        ...provinceDetails,
        { ...formData, id: provinceDetails.length ? provinceDetails[provinceDetails.length - 1].id + 1 : 1 },
      ]);
    }
    setShowForm(false);
    setFormData({ province: "", status: "Active" });
    setSelectedProvince(null);
  };

  const handleEdit = (province) => {
    setSelectedProvince(province);
    setFormData({ province: province.province, status: province.status });
    setShowForm(true);
  };

  const handleAddClick = () => {
    setSelectedProvince(null);
    setFormData({ province: "", status: "Active" });
    setShowForm(true);
  };

  return (
    <div className="province-list d-flex" style={{ gap: "1rem", padding: "1rem" }}>
      {/* Left-side Form Panel */}
      {showForm && (
        <div
          className="form-box card"
          style={{
            width: "300px",
            padding: "1rem",
            border: "1px solid #ddd",
            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          }}
        >
          <h2>{selectedProvince ? "Edit Province" : "Add Province"}</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label>Province:</label>
              <input
                type="text"
                name="province"
                value={formData.province}
                onChange={handleChange}
                required
                className="form-control"
              />
            </div>
            <div className="mb-3">
              <label>Status:</label>
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
                className="form-control"
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
            <button type="submit" className="btn btn-success me-2">
              Save
            </button>
            <button type="button" className="btn btn-secondary" onClick={() => setShowForm(false)}>
              Cancel
            </button>
          </form>
        </div>
      )}

      {/* Table Section */}
      <div className="table-container flex-grow-1">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h1>Province Details (Sri Lanka)</h1>
            <button className="btn btn-md btn-primary" onClick={handleAddClick}>
              Add Province
            </button>
          </div>
          <div className="card-body">
            <table ref={tableRef} className="table table-bordered display" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th>Province</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {provinceDetails.map((province) => (
                  <tr key={province.id}>
                    <td>{province.province}</td>
                    <td>
                      <span
                        className={`badge ${province.status === "Active" ? "bg-success" : "bg-danger"}`}
                      >
                        {province.status}
                      </span>
                    </td>
                    <td>
                      <button className="btn btn-warning btn-sm" onClick={() => handleEdit(province)}>
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProvinceDetails;
